export enum CustomComponentTypes {
    // Неизвестный тип
    Unknown,
    //Кастомное представление выбора победителя. Представление по закупке
    WinnerSelectionTableDemand,
    //Кастомное представление выбора победителя. Полотовое представление
    WinnerSelectionTableLot,
    //Кастомное представление выбора победителя. Попозиционное представление
    WinnerSelectionTablePositions,
    //Кастомное представление выбора победителя. Смешанное представление
    WinnerSelectionTableMixed,
    //Кастомное представление выбора победителя. Квалификационный отбор
    WinnerSelectionTableKO,
    //График поставок
    SupplyScheduleTable,
    // 7 занят бэкендом под PimCheckResult (рендерится только во FrontVTB)
    //Матрица выбора победителя v2: позиции лотов × заявки участников
    WinnerSelection2 = 8,
}
